export class Procedence {
    get id() {
        return this.ProcedenceState.id;
    }
    get moduleId() {
        return this.ProcedenceState.moduleId;
    }
    get name() {
        return this.ProcedenceState.name;
    }
    set name(name) {
        this.ProcedenceState.name = name;
    }
    set moduleName(moduleName) {
        this.ProcedenceState.moduleName = moduleName;
    }
    constructor(ProcedenceState) {
        this.ProcedenceState = ProcedenceState;
    }
    getState() {
        return this.ProcedenceState;
    }
}
